import { useNavigate } from "react-router-dom";
import styles from "../ClientManagement.module.css";

const ClientReports = () => {
    const navigate = useNavigate();

    return (
        <div className={styles.placeholderSection}>
            <h2>Reports</h2>
            <p>This section will provide various client reports and analytics.</p>
            <button 
                className={styles.backButton}
                onClick={() => navigate('/clients')}
            >
                ← Back to Dashboard
            </button>
        </div>
    );
};

export default ClientReports;
